import { DOMAINS } from '../gen/lang.js';

const findDeploymentEnvFromUrl = () => {
    const hostName = window.location.hostname;
    const WWW_DOMAINS = DOMAINS.map((h) => `www.${h}`);
    if (DOMAINS.includes(hostName) ||
        WWW_DOMAINS.includes(hostName)) {
        return 'prod';
    }
    if (hostName.startsWith('test.')) {
        return 'test';
    }
    switch (hostName) {
        case hostName.match(/local/)?.input:
            return 'local';
        case hostName.match(/release/)?.input:
            return 'release';
        case hostName.match(/beta-www/)?.input:
            return 'beta';
        default:
            return 'dev';
    }
};

export { findDeploymentEnvFromUrl };
//# sourceMappingURL=envService.js.map
